import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useCart } from '../context/Cart/context.js';
import '@swc/helpers';
import '@grandvisionhq/common';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/state';
import '@grandvisionhq/utils';
import '../context/CartSettings/context.js';
import '../models/add-to-cart/add-to-cart.js';
import '../models/cart/cart.js';
import '../models/subscription/subscription-details.js';
import '../models/checkoutState/checkoutState.js';
import '../utils/cart-count-var.js';
import '../utils/cart-id-var.js';
import '@grandvisionhq/commercetools';
import '../utils/get-unrecoverable-validation-errors.js';
import '../models/line-item/prescription-glasses.js';
import '../utils/get-failure-error-codes.js';
import '../utils/get-validation-errors-by-line-item.js';
import '@grandvisionhq/lib-visuals';
import '../operations/fragments/cart-details.js';
import '../operations/fragments/cart-validation-errors.js';
import '../operations/fragments/recover-inactive-cart-failure.js';
import '../operations/fragments/recover-inactive-cart-result.js';
import '../operations/mutations/add-cart-line-items.js';
import '../operations/mutations/add-cart-voucher-codes.js';
import '../operations/mutations/create-cart.js';
import '../operations/mutations/remove-cart-voucher-codes.js';
import '../operations/mutations/remove-cart-line-items.js';
import '../operations/mutations/update-cart-line-items.js';
import '../operations/mutations/replace-line-item-contact-lenses-bundle-benelux.js';
import '../operations/mutations/recover-inactive-cart.js';
import '../operations/queries/get-cart.js';
import '../operations/queries/get-total-line-items.js';
import '../operations/queries/get-cart-estimated-delivery.js';
import { mapLineItemToDataLayerEvent } from '../mappers/analytics/data-layer/line-item-to-data-layer-event.js';
import '@grandvisionhq/payments';
import '../mappers/analytics/tealium/line-item-to-tealium-product.js';

const getSanitizationPayloads = (actionItem)=>{
    const { action , actioneeSKU , lineItemId  } = actionItem;
    return {
        action,
        actioneeSKU,
        lineItemId
    };
};
const getConflictingLineItems = (sanitizationPayloads, cart)=>{
    if (!cart || !sanitizationPayloads) {
        return null;
    }
    const conflictingLineItemIds = sanitizationPayloads.map((payload)=>payload.lineItemId
    );
    return cart.lineItems.filter((lineItem)=>conflictingLineItemIds.find((id)=>id === lineItem.id
        )
    );
};
const useSanitization = ()=>{
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [validation, setValidation] = React.useState(null);
    const [sanitizationPayloads1, setSanitizationPayloads] = React.useState(null);
    const { cart  } = useCart();
    const conflictingLineItems = React.useRef(null);
    const data = {
        sanitizationPayloads: sanitizationPayloads1,
        isModalOpen,
        validation
    };
    const onSolvableValidationError = React.useCallback((solvableValidationErrors)=>{
        if (solvableValidationErrors.length > 0 && solvableValidationErrors[0]) {
            const actions = solvableValidationErrors.map((error)=>error.actionItem.action
            );
            /** When all sanitization actions are the same, confirm will resolve all validation errors at once */ if (solvableValidationErrors.length > 1 && actions.every((val, _i, arr)=>val === arr[0]
            )) {
                const sanitizationPayloads = solvableValidationErrors.map((error)=>getSanitizationPayloads(error.actionItem)
                );
                conflictingLineItems.current = getConflictingLineItems(sanitizationPayloads, cart);
                setValidation({
                    validationError: solvableValidationErrors[0],
                    singleValidation: false
                });
                setSanitizationPayloads(sanitizationPayloads);
            } else {
                const sanitizationPayloads = [
                    getSanitizationPayloads(solvableValidationErrors[0].actionItem), 
                ];
                conflictingLineItems.current = getConflictingLineItems(sanitizationPayloads, cart);
                setValidation({
                    validationError: solvableValidationErrors[0],
                    singleValidation: true
                });
                setSanitizationPayloads(sanitizationPayloads);
            }
            setIsModalOpen(true);
        }
    }, [
        cart
    ]);
    const pushRemoveLineItemDataLayerEvent = React.useCallback(()=>{
        const lineItems = conflictingLineItems.current;
        if (!lineItems) {
            return;
        }
        const removeFromCartEvent = mapLineItemToDataLayerEvent(DataLayer.DataLayerTypes.EventType.remove, lineItems, (cart === null || cart === void 0 ? void 0 : cart.id) || '');
        removeFromCartEvent && DataLayer.pushEcommerceEvent(removeFromCartEvent);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.id
    ]);
    const reset = React.useCallback(()=>{
        setIsModalOpen(false);
        setValidation(null);
        setSanitizationPayloads(null);
        conflictingLineItems.current = null;
    }, [
        setIsModalOpen,
        setValidation,
        setSanitizationPayloads
    ]);
    return [
        data,
        {
            onSolvableValidationError,
            pushRemoveLineItemDataLayerEvent,
            reset
        }, 
    ];
};

export { useSanitization };
//# sourceMappingURL=use-sanitization.js.map
